import primaryCategoryReducer from './reducers';
export { default as primaryCategoryOperations } from './operations';
export { default as primaryCategoryTypes } from './types';
export default primaryCategoryReducer;